import { useNavigate, useLocation } from '@tanstack/react-router'
import { useAuth } from '../../context/AuthContext'
import { LOGIN_PATH } from '../../routes'
import type { ReactNode } from 'react'

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { token } = useAuth()

  if (!token) {
    navigate({
      to: LOGIN_PATH,
      search: { from: location.pathname },
      replace: true,
    })
    return null
  }

  return <>{children}</>
}

export default ProtectedRoute
